module.exports = __webpack_public_path__ + "img/Wood-floor-parquet-texture-3d-BPR-free-download-seamless-HD-4K-render-full.376fd716.jpg";